<template>
  <w-dialog :dialog-show="uploadShow" @handleClose="handleClose" :top="uploadType === 'avatar' ? 15 : 15">
    <div class="content-wrapper" slot="content">
      <cube-scroll>
        <div class="content">
          <div class="modal-header flex-between">
            <span class="title">{{uploadType === 'avatar' ? '添加头像' : '添加校徽'}}</span>
            <span class="iconfont iconx" @click="handleClose"/>
          </div>
          <div class="modal-main" v-show="uploadType === 'avatar'">
<!--            <div class="progress">-->
<!--              <div v-for="(item, index) in uploadProgress" :key="index" class="progress-item"-->
<!--                   :class="{'active': currentIndex === index}">-->
<!--                <span>{{index+1}}.{{item}}</span>-->
<!--              </div>-->
<!--            </div>-->
            <template v-if="currentIndex === 0">
<!--              <div class="upload-opetating">-->
<!--                <input ref="uploadAvatar" @change="preview('avatar')" type="file">-->
<!--                <button @click="clickUpload('avatar')">本地上传</button>-->
<!--                <a class="desc">-->
<!--                  <span class="tooltip-head"/>-->
<!--                  （最大不超过 2 MB）-->
<!--                </a>-->
<!--              </div>-->
<!--              <a class="ad" target="_blank"-->
<!--                 href="http://hmp.mainto.cn/promotion_html/77e3d39c199cd4fa7720815cc5907e5e?f=2132">点击免费领取：海马体证件照 20-->
<!--                元代金券</a>-->
              <div class="avatar-upload-wrapper">
                <div class="avatar-faqs">
                  <div v-for="(item, index) in avatarFaq" :key="index" class="faq-item">
                    <div class="faq-header" @click="changeFaq(index)">
                      <span>{{item.title}}</span>
                      <span class="iconfont" :class="faqState[index] ? 'iconchevron-up' : 'iconchevron-down'"/>
                    </div>
                    <div v-html="item.description" v-show="faqState[index]" class="faq-text"></div>
                  </div>
                </div>
                <div class="btn-container flex">
                  <input ref="uploadAvatar" accept="image/*" @change="preview('avatar')" type="file" v-show="false">
                  <div class="btn local-btn flex" @click="clickUpload('avatar')">本地上传</div>
                  <div class="btn portrait-btn flex" @click="makePortrait">制作证件照</div>
                </div>
              </div>
            </template>
            <div class="image-wrapper" v-show="currentIndex === 1">
              <vue-cropper style="background: transparent" ref="cropper" :img="option.img" :canMove="option.canMove"
                           :autoCrop="option.autoCrop" :centerBox="option.centerBox" :fixed="option.fixed"
                           :fixedNumber="option.fixedNumber"/>
            </div>
            <div class="bottom" v-show="currentIndex === 1">
              <button @click="prev">上一步</button>
              <button class="theme-button" @click="upload">完成</button>
            </div>
          </div>
          <div class="school-logo" v-show="uploadType === 'logo'">
            <div class="logo-item">
              <p class="title">校徽库 <span class="description">（收录了国内 985 211学校校徽）</span></p>
              <div class="flex">
                <input v-model="term" type="text" class="search-input" placeholder="学校名称" @input="valueChange"/>
                <div>
                  <button class="upload-btn flex-center white-button" @click="clickUpload('logo')">本地上传</button>
                  <input type="file" ref="uploadLogo" class="upload-file" @change="preview('logo')">
                  <span class="desc">（必须小于1MB）</span>
                </div>
              </div>
              <div class="list-wrapper" v-show="list && list.length && searchShow">
                <cube-scroll :data="list">
                  <ul class="search-list">
                    <li v-for="(item, index) in list" :key="index" @click="getLogo('choose', item)">{{item.name}}</li>
                  </ul>
                </cube-scroll>
              </div>
            </div>
            <div class="logo-item flex-column">
              <span class="title">校徽预览</span>
              <div class="logo-wrapper">
                <img :src="logoImg ? logoImg : 'https://files.wondercv.com/default_school_log.png'" alt="">
              </div>
            </div>
            <div class="bottom">
              <!--              <button class="flex-center" @click="handleClose" v-if="">取消</button>-->
              <button class="flex-center theme-button" @click="getLogo('add')">确认</button>
            </div>
          </div>
        </div>
      </cube-scroll>
    </div>
  </w-dialog>
</template>

<script>
	import { mapActions, mapState, mapMutations } from 'vuex'
	import WDialog from '@/components/global/w-dialog'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { dataURLtoBlob, blobToFile } from '../../assets/js/utils'

	const oss = require('ali-oss')
	import { uuid } from 'vue-uuid'

	let { VueCropper } = require('vue-cropper')

	export default {
		props: {
			uploadShow: {
				type: Boolean,
				default: false
			},
			uploadType: {
				type: String,
				default: 'avatar'
			}
		},
		mixins: [ componentsMixin ],
		data () {
			return {
				uploadProgress: [ '选择照片', '剪裁图片' ],
				currentIndex: 0,
				logoImg: '',
				schoolLogoId: null,
				term: '',
				list: [],
				searchShow: false,
				schoolName: '',
				logoByUpload: false,
				completion: false,
				faqState: [ false, false, true ],
				option: {
					img: '',
					canMove: true,
					autoCrop: true,
					centerBox: true,
					fixed: true,
					fixedNumber: [ 21, 25 ]
				},
				ossConfig: {} // oss的配置
			}
		},
		components: {
			VueCropper,
			WDialog
		},
		watch: {
			uploadShow (val) {
				if (val) this.getOssConfig()
			}
		},
		computed: {
      ...mapState('cv', [ 'cv', 'profiles', 'hasProfile']),
      ...mapState('user', ['userData' ]),
			avatarFaq () {
				return [
					{
						title: '简历上是否应该放照片？',
						description: '<p>写简历最常见问题之一，基本上遵守两个原则：</p> <ol> <li>民企/国企推荐放照片，外企推荐不放照片</li> <li>中文简历推荐放照片，英文简历推荐不放照片</li> </ol> <p>如果决定放照片，一定要使用专业照相馆拍摄的登记照/职业照，一定不要用生活照。</p>'
					},
					{
						title: '简历上的照片应该是什么样的？',
						description: '<p>对于头像，我们推荐如下格式：</p> <ul> <li>剪裁：头部上方空一定距离，下面要露到肩膀左右，不要剪裁成大头照</li> <li>底色：白色最好，蓝色/黑色其次，红色和其他颜色不推荐（像结婚照）；</li> <li>发型：长发盘起来；短发梳好，尽可能不要遮挡脸部；避免头发凌乱；</li> <li>表情：微笑即可，不要特别严肃也不要大笑；</li> <li>着装：申请严肃的行业（如金融）建议西装（男生配领带；女生不必）；互联网行业建议深色衬衫或T恤；</li> </ul>'
					},
					{
						title: '是否有好的和不好的头像案例对比？',
						description: '<img alt=\'简历头像配图\' src=\'https://files.wondercv.com/APP/cveditor/photocase.png\' />'
					}
				]
			},
      // 是否是会员
			isMembership(){
				return this.userData?.is_membership
			},
		},
		methods: {
      ...mapActions('cv', [ 'createProfileData', 'updateProfileData', 'createCvDetail', 'updateCvDetail', 'updateVipProfileData', 'updateVipCvDetail' ]),
			...mapMutations('cv', [ 'changeCvDetail' ]),
      // 去制作证件照
      makePortrait() {
        if (!this.isMembership) {
          this.showToast('该功能为会员专享', 1500)
          setTimeout(() => {
            this.$fn.jump(
              `/pages/member-buy/index`,
              () => {
                this.$router.push(`/buy/member/order`)
              }
            )
          }, 1500)
        } else {
          this.$router.push({
            path: '/transfer-station/upload-portrait/index',
            query: {
              photoId: uuid.v4(),
              cvToken: this.$route.params.token
            }
          })
        }
      },
			// 点击上传事件
			clickUpload (type) {
				if (type === 'avatar') {
					this.$refs.uploadAvatar.click()
				} else if (type === 'logo') {
					this.$refs.uploadLogo.click()
				}
			},
			// 上传头像faq展开
			changeFaq (index) {
				this.faqState[index] = !this.faqState[index]
				this.$forceUpdate()
			},
			// 输入框value发生变化
			valueChange (e) {
				if (e.inputType !== 'insertCompositionText') {
					this.term = e.target.value
					if (e.target.value) {
						this.debounce(this.searchLogos, 300)
					} else {
						this.searchShow = false
					}
				}
			},
			// 搜索校徽
			async searchLogos () {
				try {
          let payload = {
            school_name: this.term
          }
          let res = await this.$api.cv.searchSchoolLogos(this.$route.params.token, payload)
          if (res.code === 1000) {
            this.list = res.data.logos
            this.searchShow = true
          }
        } catch (error) {
          console.log(error)
        }
			},
			// 上传校徽事件
			async getLogo (type, item) {
        if(!this.isMembership){
          this.showToast('该功能为会员专享', 1500)
          this.$router.push(`/buy/member/order`)
          return
        }
				// logoByUpload是判断是自己上传的校徽还是选择的校徽
        let { token, kind } = this.cv.basic_info
				if (type === 'choose') {
					this.logoImg = item.logo_url
					this.schoolLogoId = item.id
					this.searchShow = false
					this.schoolName = item.name
					this.term = item.name
					this.logoByUpload = false
          return
				} else if (type === 'add' && this.logoByUpload) {
					let store = await oss(this.ossConfig)
					let logo = `${ uuid.v1() }-logo`
					let blob = dataURLtoBlob(this.logoImg)
					let fileData = blobToFile(blob, logo)
					try {
						let res = await store.put(`cv/school_logs/${ logo }`, fileData)
						if (res.res.statusCode !== 200) {
							this.showToast('上传失败')
							return
						}
						let { url } = res
            payload = {
							logo_url: url,
							school_logo_id: this.schoolLogoId
						}
					} catch (e) {
						console.log(e)
					}
        } else if (type === 'add') {
					if (!this.logoImg) {
						this.showToast('校徽库还没有收录您的学校，请选择手动上传')
            return
          }
				}
        if (kind === 'template' || kind === 'sample') {
          try {
            let payload = JSON.parse(JSON.stringify(this.cv))
            payload.basic_info.source_cv_token = payload.basic_info.token
            payload.basic_info['sample_cv_source_token'] = payload.basic_info.token // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
            payload.basic_info.kind = null
            payload.basic_info.token = null
            payload.basic_info.school_logo_url = this.logoImg
            payload.basic_info.school_logo_id = this.schoolLogoId
            let cvRes = await this.createCvDetail(payload)
            if (cvRes.code === 1000) {
              const { basic_info: { token } } = cvRes.data
              this.$router.replace(`/cvs/${ token }/editor`)
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          try {
            // let payload = {
            //   operation_type: 'update_basic_info',
            //   basic_info: {
            //     school_logo_url: this.logoImg,
            //     school_logo_id: this.schoolLogoId
            //   }
            // }
            // await this.updateCvDetail({ token, payload })
            let payload = {
              school_logo_url: this.logoImg,
              school_logo_id: this.schoolLogoId,
            }
            let res = await this.updateVipCvDetail({ token, payload })
            if(res.code === 600213){
              this.showToast('该功能为会员专享', 1500)
						  this.$router.push(`/buy/member/order`)
              return
            }
            this.$emit('addSchoolLogo')
          } catch (error) {
            console.log(error)
          }
        }
			},
			// 头像裁剪后点击确定
			async upload () {
				let { token, kind } = this.cv.basic_info
				let store = await oss(this.ossConfig)
				let avatar = `${ uuid.v1() }-avatar`

        if(!this.isMembership){
          this.showToast('该功能为会员专享', 1500)
          this.$router.push(`/buy/member/order`)
          return
        }

				this.$refs.cropper.getCropData(async file => {
					let blob = dataURLtoBlob(file)
					let fileData = blobToFile(blob, avatar)
					try {
						let res = await store.put(`cv/profile/avatars/${ avatar }`, fileData)
						if (res.res.statusCode !== 200) {
							this.showToast('上传失败')
							return
						}
						let { url } = res
            if (kind === 'template' || kind === 'sample') {
              try {
                let payload = JSON.parse(JSON.stringify(this.cv))
                payload.basic_info.source_cv_token = payload.basic_info.token
                payload.basic_info['sample_cv_source_token'] = payload.basic_info.token // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
                payload.basic_info.kind = null
                payload.basic_info.token = null
                let cvRes = await this.createCvDetail(payload)
                if (cvRes.code === 1000) {
                  const { basic_info: { token } } = cvRes.data
                  this.createProfileData({ token, payload: { avatar_url: url }})
                  this.$router.replace(`/cvs/${ token }/editor`)
                }
              } catch (error) {
                console.log(error)
              }
            } else if (!this.profiles.id) {
							this.createProfileData({ token, payload: { avatar_url: url } })
						} else if (this.profiles.id) {
							// this.updateProfileData({ token, payload: { avatar_url: url } })
              let updateResCode = await this.updateVipProfileData({ token, payload: { avatar_url: url },  profile: {...this.profiles, avatar_url: url} })
              if(updateResCode === 600213){
                this.showToast('该功能为会员专享', 1500)
                this.$router.push(`/buy/member/order`)
                return
              }
						}
						this.$emit('uploadSuccess', url)
					} catch (e) {
						console.log(e)
					}
				})
			},
			// 上传头像点击上一步
			prev () {
				this.currentIndex = 0
			},
			// 关闭事件
			handleClose () {
				this.$emit('handleClose')
			},
			// 上传图片的回调
			preview (type) {
				let file = type === 'avatar' ? this.$refs.uploadAvatar.files : this.$refs.uploadLogo.files
				const reader = new FileReader()
				if (file[0].type !== 'image/png' && file[0].type !== 'image/gif' && file[0].type !== 'image/jpeg') {
					this.showToast('请选择正确的图片格式')
					return
				} else if (type === 'avatar' && Math.ceil(file[0].size / 1024 / 1024) > 2) {
					this.showToast('图片最大不超过 2 MB')
					return
				} else if (type === 'logo' && Math.ceil(file[0].size / 1024 / 1024) > 1) {
					this.showToast('图片最大不超过 1 MB')
					return
				}
				reader.readAsDataURL(file[0])
				reader.onload = e => {
					if (type === 'avatar') {
						this.option.img = e.currentTarget.result
						this.currentIndex = 1
					} else {
						this.logoImg = e.currentTarget.result
						this.logoByUpload = true
					}
				}
			},
			// 初始化oss参数
			async getOssConfig () {
				let res = await this.$api.cv.getOssConfig({})
				if (res.code === 1000) {
					let { access_key_id, access_key_secret, expiration, request_id, security_token, bucket_name } = res.data
					this.ossConfig = {
						region: 'oss-cn-beijing',
						accessKeyId: access_key_id,
						accessKeySecret: access_key_secret,
						bucket: bucket_name,
						stsToken: security_token
					}
				}
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  .content-wrapper {
    width: calc(100vw - 20px);
    height: calc(100vh - 60px);
    border-radius: 6px;
    .content {
      background-color: #fff;
      border-radius: 6px;
      padding-bottom: 20px;
      box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
      /*border: 1px solid rgba(0, 0, 0, 0.2);*/
      /*min-height: 450px;*/
      .modal-header {
        padding: 0 24px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        margin-bottom: 24px;
        .title {
          font-size: $font-size-large;
          color: $color-title;
          font-weight: bold;
        }
        .iconx {
          font-size: 18px;
          color: #9c9c9c;
        }
      }
      .modal-main {
        .progress {
          display: flex;
          justify-content: space-between;
          padding: 0 20px;
          border-bottom: 1px solid #f5f5f7;
          .progress-item {
            width: 120px;
            text-align: center;
            padding-bottom: 10px;
            color: $color-title;
            font-size: $font-size-medium;
          }
          .active {
            border-bottom: 2px solid $color-theme;
          }
        }
        .image-wrapper {
          width: 300px;
          height: 300px;
          margin: 20px auto 0;
          .vue-cropper {
            background-color: transparent;
          }
          img {
            max-width: 300px;
            max-height: 300px;
          }
        }
        .upload-opetating {
          display: flex;
          align-items: center;
          padding: 18px 20px;
          border-bottom: 1px solid #f5f5f7;
          input {
            display: none;
          }
          button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 32px;
            background-color: $color-theme;
            color: $color-light;
            font-size: $font-size-medium;
            border-radius: 2px;
            outline: none;
            border: none;
          }
          .desc {
            position: relative;
            display: flex;
            align-items: center;
            width: 115px;
            height: 40px;
            line-height: 18px;
            color: $color-title;
            font-size: $font-size-medium;
            text-align: center;
            margin-left: 10px;
            border-radius: 4px;
            padding: 3px;
            // background-color: $color-title;
            box-sizing: border-box;
            outline: none;
            white-space: nowrap;
            .tooltip-head {
              /*display: inline-block;*/
              display: none;
              position: absolute;
              top: 50%;
              transform: translateY(-50%) rotate(90deg);
              left: -14px;
              border-left: 7px solid transparent;
              border-top: 7px solid $color-title;
              border-right: 7px solid transparent;
              margin-left: 4px;
              height: 0;
              width: 0;
            }
          }
        }
        .ad {
          display: inline-block;
          padding-left: 20px;
          margin-top: 20px;
          color: #50a4ff;
          font-size: $font-size-medium;
        }
        .avatar-faqs {
          padding: 0 20px;
          .faq-item {
            margin-top: 24px;
            .faq-header {
              display: flex;
              justify-content: space-between;
              color: $color-title;
              font-size: $font-size-medium;
              .iconfont {
                font-weight: bold;
              }
            }
            .faq-text {
              margin-top: 21px;
              font-size: $font-size-medium;
              color: #9c9c9c;
              /deep/ p {
                line-height: 20px;
              }
              /deep/ img {
                width: 100%;
              }
              /deep/ ol,
              /deep/ ul {
                margin-bottom: 10px;
                color: #9c9c9c;
                padding-left: 18px;
                li {
                  padding: 10px;
                  line-height: 20px;
                }
              }
            }
          }
        }
        .btn-container {
          justify-content: space-between;
          padding: 20px 20px 24px;
          .btn {
            width: 148px;
            height: 48px;
            color: #fff;
            background: #fff;
            border-radius: 24px;
            align-items: center;
            justify-content: center;
            &.local-btn {
              color: #679CFF;
              background-color: rgba(103, 156, 255, .06);
            }
            &.portrait-btn {
              background-color: #679CFF;
            }
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          padding: 0 30px;
          margin-top: 20px;
          button {
            width: 100px;
            height: 40px;
            color: $color-light;
            background-color: $color-theme;
            outline: none;
            font-size: $font-size-medium-x;
            border-radius: 2px;
            box-sizing: border-box;
            &:first-child {
              background-color: $color-light;
              color: #9c9c9c;
              border: 1px solid #f5f5f7;
            }
          }
        }
      }
      .school-logo {
        padding: 0 24px;
        .logo-item {
          position: relative;
          margin-bottom: 12px;
          .title {
            display: inline-block;
            min-width: 68px;
            margin-bottom: 8px;
            color: $color-title;
            line-height: 20px;
            .description {
              color: #bcbcbc;
              font-size: $font-size-small;
              line-height: 12px;
            }
          }
          .list-wrapper {
            position: absolute;
            left: 0;
            top: 62px;
            width: calc(100% - 68px);
            background-color: $color-light;
            z-index: 1999;
            height: 190px;
            border: 1px solid #b3b3b3;
            box-sizing: border-box;
            .search-list {
              padding: 10px;
              li {
                margin-bottom: 5px;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
          .upload-file {
            display: none;
          }
          .search-input {
            width: calc(100% - 120px);
            height: 32px;
            padding: 2px 14px;
            margin-right: 12px;
            &::placeholder {
              color: #bcbcbc;
              line-height: 20px;
            }
            &:focus {
              border: 1px solid $color-theme !important;
            }
          }
          .upload-btn {
            font-size: $font-size-medium-x;
            width: 120px;
            height: 32px;
            border-radius: 2px;
            margin-bottom: 8px;
          }
          .desc {
            font-size: $font-size-small;
            color: #b3b3b3;
          }
          .logo-wrapper {
            width: 220px;
            height: 106px;
            border-radius: 4px;
            background-color: #fcfcfc;
            border: 1px solid #e8e8e8;
            display: inline-block;
            text-align: center;
            img {
              max-height: 220px;
              height: 60px;
              margin-top: 20px;
            }
          }
        }
        .bottom {
          width: 100%;
          display: flex;
          justify-content: space-between;
          button {
            width: 100%;
            height: 38px;
            border-radius: 3px;
            font-size: $font-size-medium-x;
          }
        }
      }
    }
  }
</style>
